import { doc, getDoc } from "firebase/firestore";
import dayjs from 'dayjs';
import { db } from "../firebase";

// Fetch initial available scan dates
export const fetchInitialScanDates = async (minDate, setAvailableDates, setLastFetchedDate, setError) => {
  try {
    const maxDate = dayjs().add(3, 'month').endOf('day');
    const available = [];

    // Iterate through months from minDate
    let currentMonth = minDate;
    while (currentMonth.isBefore(maxDate) || currentMonth.isSame(maxDate, 'month')) {
      const monthKey = currentMonth.format('YYYYMM');
      const docRef = doc(db, 'schedule', monthKey);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const monthData = docSnap.data();
        const days = monthData.days || {};

        for (const [dayKey, dayData] of Object.entries(days)) {
          const date = dayjs(`${monthKey}${dayKey}`, 'YYYYMMDD');
          if (
            (date.isAfter(minDate) || date.isSame(minDate, 'day')) &&
            date.isBefore(maxDate) &&
            dayData.totalScans > dayData.scansBooked
          ) {
            available.push({
              date,
              availableSlots: dayData.totalScans - dayData.scansBooked,
            });
          }
        }
      }
      currentMonth = currentMonth.add(1, 'month').startOf('month');
    }

    // Sort dates and limit to 4 weeks from first available date
    available.sort((a, b) => a.date.valueOf() - b.date.valueOf());
    if (available.length > 0) {
      const firstAvailable = available[0].date;
      const fourWeeksLater = firstAvailable.add(4, 'week').endOf('day');
      const filtered = available.filter((item) => item.date.isBefore(fourWeeksLater) || item.date.isSame(fourWeeksLater, 'day'));
      setAvailableDates(filtered);
      setLastFetchedDate(fourWeeksLater);
    } else {
      setAvailableDates([]);
      setLastFetchedDate(maxDate);
    }
  } catch (err) {
    setError("Failed to fetch available dates: " + err.message);
  }
};

// Fetch more available dates (next 2 weeks)
export const fetchMoreDates = async (lastFetchedDate, setAvailableDates, setLastFetchedDate, setError) => {
  try {
    const today = dayjs();
    const maxDate = today.add(3, 'month').endOf('day');
    const startDate = lastFetchedDate.add(1, 'day').startOf('day');
    const endDate = startDate.add(2, 'week').endOf('day');
    const available = [];

    let currentMonth = startDate;
    while (currentMonth.isBefore(endDate) || currentMonth.isSame(endDate, 'month')) {
      const monthKey = currentMonth.format('YYYYMM');
      const docRef = doc(db, 'schedule', monthKey);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const monthData = docSnap.data();
        const days = monthData.days || {};

        for (const [dayKey, dayData] of Object.entries(days)) {
          const date = dayjs(`${monthKey}${dayKey}`, 'YYYYMMDD');
          if (
            date.isAfter(startDate) &&
            (date.isBefore(endDate) || date.isSame(endDate, 'day')) &&
            date.isBefore(maxDate) &&
            dayData.totalScans > dayData.scansBooked
          ) {
            available.push({
              date,
              availableSlots: dayData.totalScans - dayData.scansBooked,
            });
          }
        }
      }
      currentMonth = currentMonth.add(1, 'month').startOf('month');
    }

    available.sort((a, b) => a.date.valueOf() - b.date.valueOf());
    setAvailableDates((prev) => [...prev, ...available]);
    setLastFetchedDate(endDate);
  } catch (err) {
    setError("Failed to fetch more dates: " + err.message);
  }
};

// Handle date selection
export const handleDateSelect = (index, availableDates, setSelectedDateIndex, setFormData) => {
  setSelectedDateIndex(index);
  setFormData((prev) => ({ ...prev, scanDate: availableDates[index].date }));
};